<template>
    <div id="LangSet">
        <nav-bar></nav-bar>
        <div class="mine-center" style="background: #f6f8f7">
<!--            <div class="mine-center-header">-->
<!--                <van-image  :src="userInfo.icon" alt="" width="70px" height="70px" round/>-->
<!--            </div>-->
            <div class="min-center-name" style="color: black">
<!--                {{ userInfo.nickname }}-->
            </div>
            <div class="min-center-right">
                <!--            <img :src="require('@/assets/image/icon/right_arrow.png')" alt="" @click="userInfoMessage()">-->
            </div>
        </div>
        <div style="height: 60px; width: 100%;"></div>
        <div style="width: 95%; margin: auto; ">
            <van-cell style="border-radius: 10px;"   :title="langText.setLang" @click="showPopup" >
                <span> {{langText.language +" "+ lang}} </span>
<!--                <van-icon name="arrow" size="10" style="float: right; margin-top: 10px;"/>-->
            </van-cell>
        </div>


        <van-popup v-model="show" style="width: 100%">
            <van-picker
                    title="选择语言"
                    show-toolbar
                    :columns="columns"
                    @confirm="onConfirm"
                    @cancel="onCancel"
            />
        </van-popup>
    </div>
</template>

<script>
    import NavBarIndexContent from "@/components/content/navbar/NavBarIndexContent";
    import { Col, Row, Icon, Image, Divider, Dialog, Cell, CellGroup, Picker,Toast,Popup } from 'vant'
    import { langPackage } from "../../config/lang/mineSetLang";
    import { selectLang } from "../../config/setLanguage"
    import { getLang, setLang } from  "@/network/mine/mine";
    export default {
        name: "LangSet",
        components: {
            NavBar: NavBarIndexContent,
            [Col.name]: Col,
            [Row.name]: Row,
            [Icon.name]: Icon,
            [Image.name]: Image,
            [Divider.name]: Divider,
            [Dialog.name]:Dialog,
            [Cell.name]:Cell,
            [CellGroup.name]:CellGroup,
            [Picker.name]:Picker,
            [Toast.name]:Toast,
            [Popup.name]:Popup,
        },
        data(){
            return{
                lang:'',
                langText:{},
                columns: ['中文', '英文'],
                show: false,
                commonText:""
            }
        },
        methods:{
            showPopup(){
                this.show = true;
            },
            //确定按钮
            onConfirm(value, index) {
                this.lang = value;
                this.show = false;
                let langValue = this.setLangValue(value);
                setLang(langValue).then(res => {
                    if (res.code == 200){
                        console.log(res);
                    }
                })
            },
            //取消按钮
            onCancel() {
                this.show = false;
            },
            setLangValue(lang){
                let strlang = ""
                switch (lang) {
                    case "中文":
                        strlang = "cn"
                        break;
                    case "英文":
                        strlang = "en"
                        break;
                }
                return strlang;
            },
            showLang(str){
              let strlang = ""
              switch (str) {
                  case "cn":
                      strlang = "中文"
                      break;
                  case "en":
                      strlang = "英文"
                      break;
              }
              return strlang;
          }

        },
        created() {

            //获取语言包
            selectLang(langPackage).then(langtxt =>{
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;
            });

            //获取当前的语言
            getLang().then(res => {
                if (res.code == 200){
                    this.lang = this.showLang(res.data)
                }
            })
        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";

</style>
